import React, { useState, useEffect } from "react";
import "./BannerRotator.css";

const banners = [
    {
        id: "inson",
        imgMobile: "https://img.freepik.com/free-vector/car-ownership-usage-isometric-composition-with-bubble-protected-car-icon-with-sign-paper-agreement_1284-54551.jpg",
        alt: "INSON страхование",
        title: "INSON – защита рядом",
        descriptionLines: [
            "Надёжное автострахование от INSON",
            "Мгновенное оформление полиса онлайн",
            "Служба поддержки 24/7 на узбекском и русском языках"
        ],
        link: "https://inson.uz",
        linkText: "Узнать больше",
        external: true,
    },
    {
        id: "alfainvest",
        imgMobile: "https://alfainvest.uz/wp-content/uploads/2023/05/%D0%A1%D1%82%D1%80%D0%B0%D1%85%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5-%D1%82%D1%80%D0%B0%D0%BD%D1%81%D0%BF%D0%BE%D1%80%D1%82%D0%BD%D1%8B%D1%85-%D1%81%D1%80%D0%B5%D0%B4%D1%81%D1%82%D0%B2-%D0%BF%D0%B5%D1%80%D0%B5%D0%B4%D0%B0%D0%B2%D0%B0%D0%B5%D0%BC%D1%8B%D1%85-%D0%B2-%D0%97%D0%B0%D0%BB%D0%BE%D0%B3-%D0%BB%D0%B8%D0%B7%D0%B8%D0%BD%D0%B3.png",
        alt: "ALFA INVEST",
        title: "ALFA INVEST – ваш финансовый щит",
        descriptionLines: [
            "КАСКО и ОСАГО по выгодным тарифам",
            "Покрытие по всей республике",
            "Быстрое оформление и выплаты без стресса"
        ],
        link: "https://alfainvest.uz",
        linkText: "Оформить сейчас",
        external: true,
    },
    {
        id: "myinsurance",
        imgMobile: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmZC3d2S5M8xn49d_Ek5WkWeOjbpSWypMAHuA8SkwkR-GdEAJpOMV45LVj7HrDL9GAUxY&usqp=CAU",
        alt: "MY INSURANCE",
        title: "MY INSURANCE – страхование без границ",
        descriptionLines: [
            "Полное покрытие, даже за границей",
            "Личный кабинет и автообновление полисов",
            "Современный подход к страхованию"
        ],
        link: "https://myinsurance.uz",
        linkText: "Перейти",
        external: true,
    },
    {
        id: "gross",
        imgMobile: "https://www.gazeta.uz/media/img/2020/10/28cCOZ16028394173274_b.jpg",
        alt: "GROSS страхование",
        title: "GROSS – стабильность и доверие",
        descriptionLines: [
            "ОСАГО за 2 минуты — онлайн",
            "КАСКО с ремонтом в лучших СТО",
            "20 лет на рынке страхования"
        ],
        link: "https://gross.uz",
        linkText: "Купить полис",
        external: true,
    }
];

export default function BannerRotator() {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % banners.length);
        }, 10000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="banner-rotator">
            {banners.map((banner, index) => (
                <div
                    key={banner.id}
                    className={`banner-slide ${index === activeIndex ? "active" : ""}`}
                >
                    <div className="banner-card">
                        <img
                            alt={banner.alt}
                            src={banner.imgMobile}
                            className="banner-image"
                            loading="lazy"
                        />
                        <div className="banner-content">
                            <h2>{banner.title}</h2>
                            {banner.description && <p>{banner.description}</p>}
                            {banner.descriptionLines &&
                                banner.descriptionLines.map((line, i) => (
                                    <p key={i}>{line}</p>
                                ))}
                            <a
                                href={banner.link}
                                target={banner.external ? "_blank" : "_self"}
                                rel={banner.external ? "noopener noreferrer" : undefined}
                                className="banner-button"
                            >
                                {banner.linkText}
                            </a>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
